import { render, staticRenderFns } from "./OrderAwaitingReview.vue?vue&type=template&id=7254d7d3&lang=pug&"
import script from "./OrderAwaitingReview.vue?vue&type=script&lang=ts&"
export * from "./OrderAwaitingReview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports